export default __webpack_public_path__ + "static/media/squareStack.6f151deb.svg";